module.exports = __webpack_public_path__ + "img/Identity-2.a928f2b9.png";